<template>
  <div style='position: absolute;left:0;top:0'>
    <button @click="togglePlay" style='width:78px;    height: 32px;opacity: 0;    cursor: pointer;
}'>{{ isPlaying ? '暂停' : '播放'}}</button>
    <audio ref="audioPlayer" :src="audioUrl" preload="auto"></audio>
  </div>
</template>

<script>
export default {
  props: {
    fileshowf: String
  },
  data() {
    return {
      audioUrl: '',
      isPlaying: false
    };
  },
  mounted() {
    this.audioUrl = this.fileshowf;
     console.log('this.audioUrl',this.audioUrl)
  },
  watch() {
    return {
      fileshowf: function (newValue) {
        this.audioUrl = newValue;
 console.log('this.audioUrl1',this.audioUrl)
      }
    };
  },
  methods: {
    togglePlay() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        try {
          if (this.isPlaying) {
            audio.pause();
          } else {
            audio.play();
          }
          this.isPlaying = !this.isPlaying;
          this.$emit('isPlayingf', this.isPlaying)
        } catch (error) {
          console.error('音频操作失败:', error);
        }
      }
    }
  }
};
</script>

<style scoped>
/* 可以在这里添加样式 */
</style>